import { render, staticRenderFns } from "./ServiceUnderConstruction.vue?vue&type=template&id=73451f33&"
import script from "./ServiceUnderConstruction.vue?vue&type=script&lang=js&"
export * from "./ServiceUnderConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports